var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contontaa"},[_c('div',{ref:"myChart",style:({ width: '6rem', height: '2.9rem' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }